import { render, staticRenderFns } from "./ModalSuporteFornecedor.vue?vue&type=template&id=199d836a&scoped=true"
import script from "./ModalSuporteFornecedor.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteFornecedor.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteFornecedor.vue?vue&type=style&index=0&id=199d836a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199d836a",
  null
  
)

export default component.exports